module.exports = __webpack_public_path__ + "img/Gratuit.331ac099.png";